$(document).ready(function () {
  // Sort & Filter
  $(".sort-menu-title").on("click", function () {
    $(".shop_page-top--header").toggleClass("active-filter");
    $(this).parent().toggleClass("sort-menu-active");

    $(".sort-list").addClass("open");
    $(".sort-menu-title").on("click", function () {
      $(".sort-list").toggleClass("open");
    });
  });
  $(".sort-menu-button").on("click", function () {
    $(".sort-list").removeClass("open");
  });

  //pagination
  $(".pagination .page").on("click", function () {
    $(".pagination .page").removeClass("active");
    $(this).addClass("active");
  });

  var swiper = new Swiper(".instagram", {
    breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween: 16,
        grid: {
          rows: 2,
        },
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
        mousewheel: {
          enabled: true,
          sensitivity: 5.5,
        },
        grid: {
          rows: 1,
        },
      },
    },
  });
});
